export default class {
	constructor(x, y, radius) {
		this.longi = x
		this.lati = y
		this.radius = radius
	}
}



// WEBPACK FOOTER //
// ./src/sites/dto/DtoRadius.js